export default {
  common: {
    save: '儲存',
    cancel: '取消',
    delete: '刪除',
    edit: '編輯',
    add: '新增',
    confirm: '確認',
    close: '關閉',
    loading: '載入中...',
    success: '成功',
    error: '錯誤',
    warning: '警告',
    info: '資訊',
    visible: '顯示',
    sectionTitle: '區塊標題',
    sectionDescription: '區塊描述',
    selectLanguage: '選擇語言',
    saveChanges: '儲存變更',
    title: '標題',
    name: '姓名',
    location: '地點',
    description: '描述',
    imageUrl: '圖片URL',
    price: '價格',
    link: '鏈接',
    copy: '複製',
    paste: '粘貼',
    show: '顯示',
    hide: '隱藏',
    heroSection: 'Hero部分'
  },
  login: {
    title: 'Travelbolt CMS',
    subtitle: '登錄管理您的內容',
    username: '用戶名',
    password: '密碼',
    signIn: '登錄',
    incorrect: '用戶名或密碼錯誤',
    failed: '登錄失敗，請重試',
    successful: '登錄成功'
  },
  menu: {
    destinations: '熱門目的地',
    flightDeals: '精選航班優惠',
    services: '我們的旅行服務',
    hotDeals: '熱門優惠和促銷',
    hotDealDetails: '熱門優惠詳情',
    flashSale: '限時搶購',
    testimonials: '旅行者評價',
    exclusiveDeals: '獨家旅行優惠',
    exclusiveTravelInsurance: '獨家旅行保險',
    heroBackground: '首頁背景圖/Logo',
    subscribers: '訂閱者管理',
    users: '用戶管理',
    languages: '語言管理',
    destinationDetails: '目的地詳情',
    flightDealDetails: '航班優惠詳情',
    footer: '頁腳管理',
    marketing: '行銷管理',
    faqs: '常見問題',
    aboutUs: '關於我們',
    contentManagement: '內容管理',
    systemManagement: '系統管理'
  },
  footer: {
    title: '頁腳管理',
    companyName: '公司名稱',
    companyDescription: '公司描述',
    socialMedia: '社交媒體',
    icon: '圖標',
    link: '鏈接',
    addSocialMedia: '添加社交媒體',
    quickLinks: '快速鏈接',
    url: '鏈接地址',
    addQuickLink: '添加快速鏈接',
    supportLinks: '支持鏈接',
    addSupportLink: '添加支持鏈接',
    contactInfo: '聯繫信息',
    address: '地址',
    phone: '電話',
    email: '電子郵件',
    businessHours: '營業時間',
    copyright: '版權信息',
    paymentMethods: '支付方式',
    paymentMethod: '支付方式',
    name: '名稱',
    imageUrl: '圖片URL',
    addPaymentMethod: '添加支付方式'
  },
  users: {
    title: '用戶管理',
    list: '用戶列表',
    addUser: '添加用戶',
    editUser: '編輯用戶',
    deleteUser: '刪除用戶',
    confirmDelete: '確定要刪除這個用戶嗎？',
    username: '用戶名',
    email: '郵箱',
    password: '密碼',
    status: '狀態',
    createdAt: '創建時間',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '用戶更新成功',
    created: '用戶創建成功',
    deleted: '用戶刪除成功',
    failed: '保存用戶失敗',
    loadFailed: '加載用戶失敗'
  },
  languages: {
    title: '語言管理',
    list: '語言列表',
    addLanguage: '添加語言',
    editLanguage: '編輯語言',
    deleteLanguage: '刪除語言',
    confirmDelete: '確定要刪除這個語言嗎？',
    code: '代碼',
    name: '名稱',
    status: '狀態',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '語言更新成功',
    created: '語言創建成功',
    deleted: '語言刪除成功',
    failed: '保存語言失敗',
    loadFailed: '加載語言失敗',
    cannotRemoveEnglish: '英語不能被刪除'
  },
  destinations: {
    title: '熱門目的地',
    add: '添加目的地',
    edit: '編輯目的地',
    name: '名稱',
    description: '描述',
    image: '圖片',
    link: '鏈接',
    status: '狀態',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '目的地更新成功',
    created: '目的地創建成功',
    deleted: '目的地刪除成功',
    failed: '保存目的地失敗',
    loadFailed: '加載目的地失敗',
    visible: '顯示',
    sectionTitle: '區塊標題',
    sectionDescription: '區塊描述',
    destinations: '目的地',
    destination: '目的地',
    rating: '評分',
    duration: '時長',
    badge: '徽章'
  },
  flightDeals: {
    title: '精選航班優惠',
    add: '添加航班優惠',
    edit: '編輯航班優惠',
    titleField: '標題',
    description: '描述',
    price: '價格',
    image: '圖片',
    link: '鏈接',
    status: '狀態',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '航班優惠更新成功',
    created: '航班優惠創建成功',
    deleted: '航班優惠刪除成功',
    failed: '保存航班優惠失敗',
    loadFailed: '加載航班優惠失敗',
    visible: '顯示',
    sectionTitle: '區塊標題',
    sectionDescription: '區塊描述',
    fromLocation: '出發地點',
    travellers: '旅行者數量',
    departureOptions: '出發選項',
    travelerOptions: '旅行者選項',
    flightDeals: '航班優惠',
    flightDeal: '航班優惠',
    destination: '目的地',
    dates: '日期',
    prices: '價格',
    originalPrice: '原價',
    discount: '折扣',
    primePriceText: '會員價格文本',
    sellingOut: '即將售罄',
    hot: '熱門',
    addDepartureLocation: '添加出發地點',
    addTravelerCount: '添加旅行者數量',
    departureOptionExists: '出發選項已存在',
    itinerary: '行程安排',
    packages: '套餐',
    addItineraryDay: '添加行程日',
    dayTitle: '日標題',
    addActivity: '添加活動',
    activity: '活動',
    addPackage: '添加套餐',
    packageName: '套餐名稱',
    packageDescription: '套餐描述',
    packageReviews: '評價數',
    addPackageFeature: '添加套餐特性',
    packageFeature: '套餐特性',
    isPopular: '是否熱門',
    isPremium: '是否高級',
    imageUrl: '圖片URL',
    subtitle: '副標題'
  },
  services: {
    title: '我們的旅行服務',
    add: '添加服務',
    edit: '編輯服務',
    titleField: '標題',
    description: '描述',
    icon: '圖標',
    status: '狀態',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '服務更新成功',
    created: '服務創建成功',
    deleted: '服務刪除成功',
    failed: '保存服務失敗',
    loadFailed: '加載服務失敗',
    visible: '顯示',
    sectionTitle: '區塊標題',
    sectionDescription: '區塊描述',
    services: '服務',
    service: '服務'
  },
  hotDeals: {
    title: '熱門優惠和促銷',
    add: '添加優惠',
    edit: '編輯優惠',
    titleField: '標題',
    description: '描述',
    price: '價格',
    image: '圖片',
    link: '鏈接',
    status: '狀態',
    actions: '操作',
    active: '開啟',
    inactive: '關閉',
    updated: '優惠更新成功',
    created: '優惠創建成功',
    deleted: '優惠刪除成功',
    failed: '保存優惠失敗',
    loadFailed: '加載優惠列表失敗',
    deals: '優惠列表',
    deal: '優惠',
    addDeal: '添加優惠',
    validDates: '有效期',
    bookingDeadline: '預訂截止日期',
    originalPrice: '原價',
    badge: '徽章'
  },
  hotDealDetails: {
    list: '熱門優惠詳情列表',
    addHotDeal: '添加熱門優惠詳情',
    editHotDeal: '編輯熱門優惠詳情',
    dealKey: '優惠標識',
    dealKeyPlaceholder: '輸入優惠標識（例如：africa）',
    title: '標題',
    language: '語言',
    status: '狀態',
    actions: '操作',
    created: '熱門優惠詳情創建成功',
    updated: '熱門優惠詳情更新成功',
    deleted: '熱門優惠詳情刪除成功',
    failed: '保存熱門優惠詳情失敗',
    mapSection: '地圖區域',
    detailSection: '詳情圖文區域',
    itinerarySection: '建議行程區域',
    ctaSection: '行動號召（CTA）',
    sectionTitle: '區域標題',
    sectionDescription: '區域描述',
    enterSectionTitle: '輸入區域標題',
    enterSectionDescription: '輸入區域描述',
    mapMarkers: '地圖標記點',
    marker: '標記點',
    addMarker: '添加標記點',
    countryCode: '國家代碼',
    countryName: '國家名稱',
    color: '顏色',
    latitude: '緯度',
    longitude: '經度',
    exampleKE: '例如：KE',
    exampleKenya: '例如：肯尼亞',
    countryLabel: '國家標籤',
    exampleCountryLabel: '例如：肯尼亞 · 馬賽馬拉',
    badgeCode: '徽章代碼',
    badgeColor: '徽章顏色',
    detailTitle: '詳情標題',
    detailDescription: '詳情描述',
    enterDetailTitle: '輸入詳情標題',
    enterDetailDescription: '輸入詳情描述',
    highlights: '亮點列表',
    highlight: '亮點',
    addHighlight: '添加亮點',
    iconClass: '圖標類名',
    iconColor: '圖標顏色',
    highlightText: '亮點文字',
    exampleIcon: '例如：fa-binoculars',
    enterHighlightDescription: '輸入亮點描述',
    tags: '標籤列表',
    addTag: '添加標籤',
    enterTagContent: '輸入標籤內容',
    gallery: '圖片畫廊',
    image: '圖片',
    addImage: '添加圖片',
    imageUrl: '圖片URL',
    imageDescription: '圖片描述',
    imageTitle: '圖片標題',
    enterImageUrl: '輸入圖片URL',
    enterImageDescription: '輸入圖片描述',
    enterImageTitle: '輸入圖片標題',
    upload: '上傳',
    itineraryDays: '行程天數',
    itinerary: '行程',
    addItinerary: '添加行程',
    dayRange: '天數範圍',
    location: '地點',
    description: '描述',
    exampleDayRange: '例如：第 1–4 天',
    exampleLocation: '例如：肯尼亞 · 馬賽馬拉',
    enterItineraryDescription: '輸入行程描述',
    ctaBackgroundImage: 'CTA背景圖',
    ctaTitle: 'CTA標題',
    ctaDescription: 'CTA描述',
    ctaButtonText: 'CTA按鈕文字',
    ctaButtonLink: 'CTA按鈕鏈接',
    enterCtaTitle: '輸入CTA標題',
    enterCtaDescription: '輸入CTA描述',
    enterButtonText: '輸入按鈕文字',
    enterButtonLink: '輸入按鈕鏈接'
  },
  flashSale: {
    title: '限時搶購：僅限48小時',
    add: '添加限時搶購',
    edit: '編輯限時搶購',
    titleField: '標題',
    description: '描述',
    price: '價格',
    originalPrice: '原價',
    image: '圖片',
    link: '鏈接',
    status: '狀態',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '限時搶購更新成功',
    created: '限時搶購創建成功',
    deleted: '限時搶購刪除成功',
    failed: '保存限時搶購失敗',
    loadFailed: '加載限時搶購失敗',
    countdownEndDate: '倒計時結束日期',
    flashDeals: '限時優惠',
    flashDeal: '限時優惠',
    addFlashDeal: '添加限時優惠',
    discount: '折扣'
  },
  testimonials: {
    title: '旅行者評價',
    add: '添加評價',
    edit: '編輯評價',
    name: '姓名',
    comment: '評價內容',
    rating: '評分',
    image: '圖片',
    status: '狀態',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '評價更新成功',
    created: '評價創建成功',
    deleted: '評價刪除成功',
    failed: '保存評價失敗',
    loadFailed: '加載評價失敗',
    testimonials: '評價',
    testimonial: '評價',
    addTestimonial: '添加評價',
    avatarUrl: '頭像URL',
    review: '評價內容'
  },
  exclusiveDeals: {
    title: '獨家旅行優惠',
    add: '添加獨家優惠',
    edit: '編輯獨家優惠',
    titleField: '標題',
    description: '描述',
    buttonText: '按鈕文本',
    image: '圖片',
    link: '鏈接',
    status: '狀態',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '獨家優惠更新成功',
    created: '獨家優惠創建成功',
    deleted: '獨家優惠刪除成功',
    failed: '保存獨家優惠失敗',
    loadFailed: '加載獨家優惠失敗',
    backgroundImageUrl: '背景圖片URL',
    newsletterForm: '通訊表單',
    formTitle: '表單標題',
    formDescription: '表單描述',
    successMessage: '成功消息',
    privacyText: '隱私聲明文本'
  },
  exclusiveTravelInsurance: {
    title: '獨家旅行保險',
    features: '特性',
    feature: '特性',
    addFeature: '添加特性',
    imageUrl: '圖片URL',
    buttonText: '按鈕文本',
    buttonLink: '按鈕鏈接'
  },
  heroBackground: {
    title: '首頁背景圖管理',
    imageUrl: '背景圖片URL'
  },
  subscribers: {
    title: '訂閱者管理',
    sendEmail: '發送郵件',
    emailSubject: '郵件標題',
    emailContent: '郵件內容',
    loading: '加載訂閱者中...',
    id: 'ID',
    email: '郵箱',
    name: '姓名',
    phone: '電話',
    status: '狀態',
    subscribedAt: '訂閱時間',
    lastEmail: '上次發送',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    deactivate: '停用',
    activate: '激活',
    enterEmailSubject: '輸入郵件標題',
    enterEmailContent: '輸入郵件內容',
    loadFailed: '加載訂閱者失敗，請重試。',
    loadFailedMessage: '加載訂閱者失敗',
    activateSuccess: '訂閱者激活成功',
    deactivateSuccess: '訂閱者停用成功',
    updateFailed: '更新訂閱者狀態失敗',
    enterSubjectAndContent: '請輸入標題和內容',
    sendFailed: '發送郵件失敗',
    confirmDelete: '確定要刪除訂閱者 {email} 嗎？',
    deleteSuccess: '刪除訂閱者成功',
    deleteFailed: '刪除訂閱者失敗'
  },
  destinationDetails: {
    title: '目的地詳情管理',
    list: '目的地詳情列表',
    addDestination: '添加目的地',
    editDestination: '編輯目的地',
    deleteDestination: '刪除目的地',
    confirmDelete: '確定要刪除這個目的地嗎？',
    destinationKey: '目的地標識',
    destinationKeyPlaceholder: '輸入目的地標識（例如：bali）',
    language: '語言',
    title: '標題',
    titlePlaceholder: '輸入目的地標題',
    subtitle: '副標題',
    subtitlePlaceholder: '輸入目的地副標題',
    rating: '評分',
    reviews: '評價數',
    reviewsPlaceholder: '輸入評價數',
    country: '國家',
    countryPlaceholder: '輸入國家名稱',
    bannerImage: '橫幅圖片',
    bannerImagePlaceholder: '輸入橫幅圖片URL',
    description: '描述',
    descriptionPlaceholder: '輸入目的地描述',
    spots: '秘密景點',
    spot: '景點',
    addSpot: '添加景點',
    spotName: '景點名稱',
    spotImage: '景點圖片',
    bestTime: '最佳時間',
    location: '位置',
    spotDescription: '景點描述',
    travelTips: '旅行提示',
    tip: '提示',
    addTravelTip: '添加旅行提示',
    tipTitle: '提示標題',
    addTipItem: '添加提示項',
    tipItem: '提示項',
    ctaTitle: 'CTA標題',
    ctaTitlePlaceholder: '輸入CTA標題',
    ctaDescription: 'CTA描述',
    ctaDescriptionPlaceholder: '輸入CTA描述',
    status: '狀態',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '目的地更新成功',
    created: '目的地創建成功',
    deleted: '目的地刪除成功',
    failed: '保存目的地失敗',
    loadFailed: '加載目的地失敗'
  },
  header: {
    logo: 'Travelbolt CMS',
    logout: '退出登錄',
    loggedInAs: '登錄用戶：'
  },
  flightDealDetails: {
    title: '航班優惠詳情管理',
    list: '航班優惠詳情列表',
    addFlightDeal: '添加航班優惠',
    editFlightDeal: '編輯航班優惠',
    deleteFlightDeal: '刪除航班優惠',
    confirmDelete: '確定要刪除這個航班優惠嗎？',
    dealKey: '優惠標識',
    dealKeyPlaceholder: '輸入優惠標識（例如：london）',
    language: '語言',
    title: '標題',
    titlePlaceholder: '輸入航班優惠標題',
    subtitle: '副標題',
    subtitlePlaceholder: '輸入航班優惠副標題',
    rating: '評分',
    reviews: '評價數',
    reviewsPlaceholder: '輸入評價數',
    country: '國家',
    countryPlaceholder: '輸入國家名稱',
    bannerImage: '橫幅圖片',
    bannerImagePlaceholder: '輸入橫幅圖片URL',
    overview: '概覽',
    addOverviewFeature: '添加概覽特性',
    icon: '圖標',
    featureTitle: '特性標題',
    featureDescription: '特性描述',
    itinerary: '行程安排',
    addItinerary: '添加行程',
    addItineraryDay: '添加行程日',
    dayTitle: '日標題',
    addActivity: '添加活動',
    addPackageSection: '添加套餐部分',
    activity: '活動',
    packages: '套餐',
    addPackage: '添加套餐',
    packageName: '套餐名稱',
    packageDescription: '套餐描述',
    price: '價格',
    originalPrice: '原價',
    packageReviews: '評價數',
    addPackageFeature: '添加套餐特性',
    packageFeature: '套餐特性',
    isPopular: '是否熱門',
    isPremium: '是否高級',
    reviews: '評價',
    addReview: '添加評價',
    reviewerName: '評價者姓名',
    avatar: '頭像URL',
    reviewContent: '評價內容',
    reviewDate: '評價日期',
    ctaTitle: 'CTA標題',
    ctaTitlePlaceholder: '輸入CTA標題',
    ctaDescription: 'CTA描述',
    ctaDescriptionPlaceholder: '輸入CTA描述',
    cta: 'CTA',
    sectionVisibility: '區塊可見性',
    reviewsSection: '評價區塊',
    addImage: '添加圖片',
    sectionTitle: '區塊標題',
    description: '描述',
    imageUrl: '圖片URL',
    dealKeyRequired: '優惠標識不能為空',
    languageRequired: '語言不能為空',
    titleRequired: '標題不能為空',
    countryRequired: '國家不能為空',
    status: '狀態',
    actions: '操作',
    active: '激活',
    inactive: '未激活',
    updated: '航班優惠更新成功',
    created: '航班優惠創建成功',
    deleted: '航班優惠刪除成功',
    failed: '保存航班優惠失敗',
    loadFailed: '加載航班優惠失敗',
    tripOverview: '行程概覽',
    tripOverviewTitle: '行程概覽標題',
    tripOverviewDescription: '行程概覽描述',
    tripOverviewDays: '天數',
    tripOverviewDaysPlaceholder: '輸入行程天數',
    tripOverviewDaysDescription: '天數描述',
    tripOverviewDaysDescriptionPlaceholder: '輸入天數描述',
    tripOverviewBestSeason: '最佳季節',
    tripOverviewBestSeasonPlaceholder: '輸入最佳季節',
    tripOverviewSeasonDescription: '季節描述',
    tripOverviewSeasonDescriptionPlaceholder: '輸入季節描述',
    tripOverviewTravelStyle: '旅行風格',
    tripOverviewTravelStylePlaceholder: '輸入旅行風格',
    tripOverviewStyleDescription: '風格描述',
    tripOverviewStyleDescriptionPlaceholder: '輸入風格描述',
    labelSettings: '標籤設置',
    daysLabel: '行程天數標籤',
    daysLabelPlaceholder: '輸入行程天數標籤',
    seasonLabel: '最佳季節標籤',
    seasonLabelPlaceholder: '輸入最佳季節標籤',
    styleLabel: '旅行風格標籤',
    styleLabelPlaceholder: '輸入旅行風格標籤',
    packageButtonText: '套餐按鈕文字',
    packageButtonTextPlaceholder: '輸入套餐按鈕文字',
    packageButtonLink: '套餐按鈕鏈接',
    packageButtonLinkPlaceholder: '輸入套餐按鈕鏈接',
    ctaButtonText: 'CTA按鈕文字',
    ctaButtonTextPlaceholder: '輸入CTA按鈕文字',
    ctaButtonLink: 'CTA按鈕鏈接',
    ctaButtonLinkPlaceholder: '輸入CTA按鈕鏈接',
    overviewButtonText: '概覽按鈕文字',
    overviewButtonTextPlaceholder: '輸入概覽按鈕文字（如：查看6日行程靈感）',
    popularLabelPlaceholder: '人氣標籤文案（如：人氣之選）',
    premiumLabelPlaceholder: '高級標籤文案（如：尊享）'
  },
  faqs: {
    title: '常見問題管理',
    addCategory: '新增分類',
    editCategory: '編輯分類',
    addFaq: '新增問題',
    editFaq: '編輯問題',
    title: '標題',
    order: '排序',
    visible: '顯示',
    question: '問題',
    answer: '答案',
    faqs: '個問題',
    saveSuccess: '儲存成功',
    updateSuccess: '更新成功',
    deleteSuccess: '刪除成功',
    saveError: '儲存失敗',
    updateError: '更新失敗',
    deleteError: '刪除失敗',
    loadError: '載入失敗'
  },
  aboutUs: {
    title: '關於我們管理',
    missionSection: '使命部分',
    whyChooseUsSection: '為什麼選擇我們部分',
    contactInfoSection: '聯繫信息部分',
    title: '標題',
    subtitle: '副標題',
    description: '描述',
    content: '內容',
    icon: '圖標',
    office: '辦公室',
    phone: '電話',
    phoneHours: '電話時間',
    email: '電子郵件',
    emailResponse: '郵件回覆時間'
  },
  privacyPolicy: {
    title: '隱私政策管理',
    content: '內容',
    heroTitle: '英雄標題',
    enterHeroTitle: '輸入英雄標題',
    heroSubtitle: '英雄副標題',
    enterHeroSubtitle: '輸入英雄副標題',
    lastUpdated: '最後更新',
    enterLastUpdated: '輸入最後更新日期',
    note: '說明',
    enterNote: '輸入說明',
    part1Title: '第一部分標題',
    ourPledge: '我們的承諾',
    enterOurPledge: '輸入我們的承諾',
    cookies: 'Cookie',
    enterCookiesText1: '輸入Cookie文本',
    enterCookiesText2: '輸入Cookie文本',
    analytics: '分析',
    enterAnalyticsText: '輸入分析文本',
    remarketing: '再行銷',
    enterRemarketingText: '輸入再行銷文本',
    optingOut: '選擇退出',
    enterOptingOutText1: '輸入選擇退出文本',
    enterOptingOutText2: '輸入選擇退出文本',
    collection: '收集',
    enterCollectionText1: '輸入收集文本',
    enterCollectionText2: '輸入收集文本',
    useOfData: '個人數據的使用',
    enterUseOfDataText: '輸入數據使用文本',
    retention: '保留',
    enterRetentionText: '輸入保留文本',
    access: '訪問和更正',
    enterAccessText1: '輸入訪問文本',
    accessItem1: '訪問項目 1',
    enterAccessItem1: '輸入訪問項目 1',
    accessItem2: '訪問項目 2',
    enterAccessItem2: '輸入訪問項目 2',
    accessItem3: '訪問項目 3',
    enterAccessItem3: '輸入訪問項目 3',
    accessItem4: '訪問項目 4',
    enterAccessItem4: '輸入訪問項目 4',
    accessItem5: '訪問項目 5',
    enterAccessItem5: '輸入訪問項目 5',
    enterAccessText2: '輸入訪問文本',
    byPost: '通過郵寄',
    enterAddress: '輸入地址',
    byEmail: '通過郵件',
    enterEmail: '輸入郵箱',
    enterAccessText3: '輸入訪問文本',
    security: '安全',
    enterSecurityText: '輸入安全文本',
    part2Title: '第二部分標題',
    enterPersonalInformationText1: '輸入個人信息文本',
    enterPersonalInformationText2: '輸入個人信息文本',
    enterPersonalInformationText3: '輸入個人信息文本',
    purposes: '收集個人信息的目的',
    enterPurpose1: '輸入目的 1',
    enterPurpose2: '輸入目的 2',
    enterPurpose3: '輸入目的 3',
    enterPurpose4: '輸入目的 4',
    enterPurpose5: '輸入目的 5',
    enterPurpose6: '輸入目的 6',
    enterPurpose7: '輸入目的 7',
    enterPurpose8: '輸入目的 8',
    enterPurpose9: '輸入目的 9',
    enterPurpose10: '輸入目的 10',
    enterPurpose11: '輸入目的 11',
    enterPurpose12: '輸入目的 12',
    enterPurpose13: '輸入目的 13',
    enterPurpose14: '輸入目的 14',
    enterRecipientsText: '輸入接收者文本',
    recipients: '個人信息的接收者',
    enterRecipient1: '輸入接收者 1',
    enterRecipient2: '輸入接收者 2',
    enterRecipient3: '輸入接收者 3',
    enterRecipient4: '輸入接收者 4',
    enterRecipient5: '輸入接收者 5',
    enterRecipient6: '輸入接收者 6',
    enterRecipient7: '輸入接收者 7',
    enterUnsubscribeText: '輸入退訂文本',
    enterConsentText: '輸入同意文本',
    enterContactText: '輸入聯繫文本',
    enterWebsiteNote: '輸入網站說明'
  },
  termsAndConditions: {
    title: '條款和條件管理',
    content: '內容',
    heroTitle: '英雄標題',
    enterHeroTitle: '輸入英雄標題',
    heroSubtitle: '英雄副標題',
    enterHeroSubtitle: '輸入英雄副標題',
    lastUpdated: '最後更新',
    enterLastUpdated: '輸入最後更新日期',
    part1Title: '第一部分標題',
    introduction: '介紹',
    enterIntroductionText1: '輸入介紹文本',
    enterIntroductionText2: '輸入介紹文本',
    copyrightNotice: '版權聲明',
    enterCopyrightText1: '輸入版權文本',
    enterCopyrightText2: '輸入版權文本',
    trademarkNotice: '商標聲明',
    enterTrademarkText: '輸入商標文本',
    acceptableUse: '可接受的使用',
    enterAcceptableUseText1: '輸入可接受使用文本',
    enterAcceptableUseText2: '輸入可接受使用文本',
    enterAcceptableUseText3: '輸入可接受使用文本',
    noWarranties: '無保證',
    enterNoWarrantiesText1: '輸入無保證文本',
    noWarrantiesItem1: '無保證項目 1',
    enterNoWarrantiesItem1: '輸入無保證項目 1',
    noWarrantiesItem2: '無保證項目 2',
    enterNoWarrantiesItem2: '輸入無保證項目 2',
    noWarrantiesItem3: '無保證項目 3',
    enterNoWarrantiesItem3: '輸入無保證項目 3',
    noWarrantiesItem4: '無保證項目 4',
    enterNoWarrantiesItem4: '輸入無保證項目 4',
    noWarrantiesItem5: '無保證項目 5',
    enterNoWarrantiesItem5: '輸入無保證項目 5',
    noWarrantiesItem6: '無保證項目 6',
    enterNoWarrantiesItem6: '輸入無保證項目 6',
    noWarrantiesItem7: '無保證項目 7',
    enterNoWarrantiesItem7: '輸入無保證項目 7',
    enterNoWarrantiesText2: '輸入無保證文本',
    generalLimitation: '一般責任限制',
    enterGeneralLimitationText1: '輸入一般責任限制文本',
    enterGeneralLimitationText2: '輸入一般責任限制文本',
    enterGeneralLimitationText3: '輸入一般責任限制文本',
    enterGeneralLimitationText4: '輸入一般責任限制文本',
    enterGeneralLimitationText5: '輸入一般責任限制文本',
    thirdParties: '第三方',
    enterThirdPartiesText1: '輸入第三方文本',
    enterThirdPartiesText2: '輸入第三方文本',
    thirdPartyTravelService: '第三方旅行服務提供商',
    enterThirdPartyTravelServiceText1: '輸入第三方旅行服務文本',
    enterThirdPartyTravelServiceText2: '輸入第三方旅行服務文本',
    userComments: '用戶評論',
    enterUserCommentsText: '輸入用戶評論文本',
    responseToRequests: '對請求的響應',
    enterResponseToRequestsText: '輸入對請求的響應文本',
    linksToOther: '指向其他網站的鏈接',
    enterLinksToOtherText: '輸入指向其他網站的鏈接文本',
    terminationOfUsage: '使用終止',
    enterTerminationOfUsageText: '輸入使用終止文本',
    pricingErrors: '定價錯誤',
    enterPricingErrorsText1: '輸入定價錯誤文本',
    enterPricingErrorsText2: '輸入定價錯誤文本',
    enterPricingErrorsText3: '輸入定價錯誤文本',
    creditCardSubmissions: '信用卡提交',
    enterCreditCardSubmissionsText: '輸入信用卡提交流本',
    membershipLoyalty: '會員和忠誠度計劃',
    enterMembershipLoyaltyText: '輸入會員忠誠度文本',
    miscellaneous: '雜項',
    enterMiscellaneousText1: '輸入雜項文本',
    miscellaneousItem1: '雜項項目 1',
    enterMiscellaneousItem1: '輸入雜項項目 1',
    miscellaneousItem2: '雜項項目 2',
    enterMiscellaneousItem2: '輸入雜項項目 2',
    enterMiscellaneousText2: '輸入雜項文本',
    enterMiscellaneousText3: '輸入雜項文本',
    enterMiscellaneousText4: '輸入雜項文本',
    enterMiscellaneousText5: '輸入雜項文本',
    part2Title: '第二部分標題',
    limitationOfLiability: '責任限制',
    enterLimitationOfLiabilityText: '輸入責任限制文本',
    ticketRestrictions: '機票限制',
    enterTicketRestrictionsText: '輸入機票限制文本',
    ticketPayment: '機票支付',
    enterTicketPaymentText: '輸入機票支付文本',
    otherServiceFee: '其他服務費',
    enterOtherServiceFeeText: '輸入其他服務費文本',
    service: '服務',
    fee: '費用',
    service1: '預訂費',
    service2: '取消費',
    service3: '更改費',
    fuelSurcharge: '燃油附加費',
    enterFuelSurchargeText: '輸入燃油附加費文本',
    useOfTicket: '機票使用',
    enterUseOfTicketText1: '輸入機票使用文本',
    enterUseOfTicketText2: '輸入機票使用文本',
    enterUseOfTicketText3: '輸入機票使用文本',
    enterUseOfTicketText4: '輸入機票使用文本',
    internationalTravel: '國際旅行',
    enterInternationalTravelText: '輸入國際旅行文本'
  }
}